import memoize from 'lru-memoize';

import {offlineConversationContents} from './offlineConversationContents';
import {setupOfflineResources} from './offlineResources';

// Memoized because it will be called more than once if the component gets remounted and there's really no point doing all this again.
export const setupOfflineConversations = memoize(1)(async (userId: number, isUserVisitor: boolean) => {
  const isSetup = await setupOfflineResources(userId, isUserVisitor);
  if (!isSetup) {
    return false;
  }

  offlineConversationContents.setup();
  return true;
});
